export default __webpack_public_path__ + "static/media/Doc.0c2f4bf6.svg";